var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageMaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3412 44.5407C29.0666 44.1516 29.8839 43.9665 30.7061 44.005C31.5284 44.0435 32.3248 44.3042 33.0106 44.7594L33.0806 44.8059L56.0963 62.3868C56.9643 62.9815 57.6772 63.7762 58.1747 64.7043C58.6868 65.6597 58.9548 66.727 58.9547 67.811C58.9547 67.8111 58.9547 67.8109 58.9547 67.811V80.0003H53.8941V67.811C53.8941 67.5613 53.8324 67.3151 53.7145 67.0951C53.5965 66.875 53.426 66.6875 53.218 66.5493L53.1487 66.5032L31.0011 49.5855V80.0003H25.9406V48.5522C25.9407 47.729 26.164 46.9209 26.5868 46.2146C27.0095 45.5082 27.6158 44.9298 28.3412 44.5407Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6588 44.5407C94.9334 44.1516 94.1161 43.9665 93.2939 44.005C92.4716 44.0435 91.6752 44.3042 90.9894 44.7594L90.9194 44.8059L67.9037 62.3868C67.0357 62.9815 66.3228 63.7762 65.8253 64.7043C65.3132 65.6597 65.0452 66.727 65.0453 67.811C65.0453 67.8111 65.0453 67.8109 65.0453 67.811V80.0003H70.1059V67.811C70.1059 67.5613 70.1676 67.3151 70.2855 67.0951C70.4035 66.875 70.574 66.6875 70.782 66.5493L70.8513 66.5032L92.9989 49.5855V80.0003H98.0594V48.5522C98.0593 47.729 97.836 46.9209 97.4132 46.2146C96.9905 45.5082 96.3842 44.9298 95.6588 44.5407Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069787"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageMaker);
export default __webpack_public_path__ + "static/media/page-maker.2d9bc13d96261e1778b50c51e0b687f5.svg";
export { ForwardRef as ReactComponent };